import React from 'react';
import { CircularProgress } from '@mui/material';

import styles from './loader.module.css';

type LoaderProps = {
  color?: string;
}

const Loader = (props: LoaderProps) => {
  const { color = 'var(--primary-color)' } = props;

  return (
    <div className={styles.centered}>
      <CircularProgress style={{ color }} />
    </div>
  );
};

export default Loader;
